import React from 'react'
import { Col, Row } from 'react-bootstrap'
import StepIndicator from './StepIndicator'
import StepSelector from './StepSelector'


const Footer = (props) => {

   const { validateCurrentOptionForm } = props

   const handleValidation = () => {
      validateCurrentOptionForm(true)
   }
   return (
      <div className='d-lg-none' style={{ flex: 'none' }}>
         <Row>
            <Col md={{ span: 8, offset: 2 }} xl={{ span: 6, offset: 3 }} xxl={{ span: 4, offset: 4 }}>
               <StepIndicator {...props} handleValidation={handleValidation} openOptionsOnClick={true} />
            </Col>
         </Row>
         <Row>
            <Col md={{ span: 8, offset: 2 }} xl={{ span: 6, offset: 3 }} xxl={{ span: 4, offset: 4 }}>
               <StepSelector {...props} handleValidation={handleValidation} />
            </Col>
         </Row>
      </div>
   )
}
export default Footer